import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.surface.dark};
  color: ${({ theme }) => theme.colors.text.light};
  padding: ${({ theme }) => theme.spacing.lg} 0;
  margin-top: auto;
  border-radius: ${({ theme }) => theme.borderRadius.medium}
    ${({ theme }) => theme.borderRadius.medium} 0 0;
  position: relative;
  z-index: 10;

  @media (max-width: 768px) {
    border-radius: 0;
    padding-bottom: 120px;
  }
`;

const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.colors.text.light};
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
  margin: 0 ${({ theme }) => theme.spacing.sm};

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="text-md-end">
            <div>© 2025 מזרח ללא גבולות</div>
          </Col>
          <Col md={6} className="text-md-start">
            <FooterLink to="/about">אודות</FooterLink>
            <FooterLink to="/terms">תקנון השימוש באתר</FooterLink>
            <FooterLink to="/contact">צור קשר</FooterLink>
          </Col>
        </Row>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
